type TranslationsState = Record<string, Record<string, string>>;

const initialTranslationsState: TranslationsState = {};

export type { TranslationsState };
export default initialTranslationsState;
